import React from 'react';
import { Button, Text } from '../../../../design-system';
import { LAST_UPDATED_COLUMN } from '../../../shared-constants';
import { required, formatTime } from '../../../../helpers/utils';
import DeadlineCell from '../../../../components/DeadlineCell';
import DeleteButton from '../../../../components/DeleteButton';
import DescriptionTooltip from '../../../../components/DescriptionTooltip';
import StyledLink from '../../../../components/StyledLink';

const TYPE_OPTIONS = [
  { value: 'Award', label: 'Award' },
  { value: 'Article', label: 'Article' },
  { value: 'Recognition', label: 'Recognition' },
];

export const COLUMNS = [
  { Header: 'Title', accessor: 'title' },
  {
    Header: 'Type',
    accessor: 'type',
    type: 'dropdown',
    Cell: ({ cell: { value } }) => value && value,
  },
  {
    Header: 'Date Of',
    accessor: 'date',
    type: 'date',
    Cell: ({ cell: { value } }) => value && formatTime(value),
  },
  {
    Header: 'Expires',
    accessor: 'expires',
    type: 'date',
    Cell: DeadlineCell,
  },
  {
    Header: 'Notes',
    accessor: 'notes',
    Cell: (props) => <DescriptionTooltip {...props} maxLength={100} />,
  },
  { ...LAST_UPDATED_COLUMN },
  {
    Header: '',
    accessor: 'handleDeleteAward',
    Cell: ({ row: { original }, cell: { value: handleDeleteAward } }) => (
      <Button.Group alignItems="center" justifyContent="flex">
        <StyledLink
          to={`/vault/${original.client_id}/awards-recognition-publicity/${original.id}`}
        >
          <Text id="expand-button">more info</Text>
        </StyledLink>
        {original.canEdit && (
          <DeleteButton
            variant="primaryText"
            onClick={() => handleDeleteAward(original)}
          />
        )}
      </Button.Group>
    ),
  },
];

export const MODAL_FIELDS = [
  { name: 'title', label: 'Title', validate: required },
  {
    name: 'type',
    label: 'Type',
    type: 'dropdown',
    component: 'select',
    options: TYPE_OPTIONS,
  },
  { name: 'link', label: 'Link' },
  { name: 'date', label: 'Date Of', type: 'date' },
  { name: 'expires', label: 'Expires', type: 'date' },
  { name: 'notes', label: 'Notes', multiline: true },
];

export const SINGLE_ENTITY_FIELDS = [
  {
    label: 'Type',
    name: 'type',
    component: 'select',
    options: TYPE_OPTIONS,
  },
  {
    label: 'Title',
    name: 'title',
  },
  {
    label: 'Date Of',
    name: 'date',
    type: 'date',
  },
  {
    label: 'Expires',
    name: 'expires',
    type: 'date',
  },
  {
    label: 'Notes',
    name: 'notes',
    multiline: true,
  },
];
